import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/api/api.js";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";

const CertificateTaxList = ({ company }) => {
  const { t } = useTranslation();
  const [requestTickets, setRequestTickets] = useState([]);
  const fetchListRequestTickets = async () => {
    try {
      const response = await api.get(`/companies/${company.id}/requestTickets`);
      setRequestTickets(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchListRequestTickets();
  }, []);
  return (
    <>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th>{capitalizeFirstLetter(t("purchased package"))}</th>
            <th>{capitalizeFirstLetter(t("requested date"))}</th>
            <th>{capitalizeFirstLetter(t("requested by"))}</th>
            <th>{capitalizeFirstLetter(t("quantity tickets"))}</th>
            <th>{capitalizeFirstLetter(t("approved by"))}</th>
            <th>{capitalizeFirstLetter(t("revision"))}</th>
          </tr>
        </thead>
        <tbody>
          {requestTickets.map((ticket) => (
            <tr key={ticket.id}>
              <td>{ticket.packageName}</td>
              <td>{ticket.createdAtHuman}</td>
              <td>{ticket.requestedBy}</td>
              <td>{ticket.ticketsRequested}</td>
              <td>{ticket.approvedBy}</td>
              <td>
                <Link to={`/tickets/${company.id}/${ticket.id}/review`}>
                  {t("review")}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default CertificateTaxList;
